import React from 'react';
import PropTypes from 'prop-types';

import Illustration from '@component/illustration';
import I18n from '@module/i18n';

const Upsell = ({ upsellKey, onHandleUpsellClick, onNewTransfer }) => {
  const linkOptions = {
    href: I18n.t(`transfer.${upsellKey}.href`),
    onClick: onHandleUpsellClick,
  };

  // External links are external
  if (linkOptions['href'].match(/^https?/)) {
    linkOptions['rel'] = 'external';
  }

  return (
    <React.Fragment>
      <div className="transfer__contents">
        <div className="transfer__upsell">
          <Illustration type={`transfer-${upsellKey}`} />
          <h2>{I18n.t(`transfer.${upsellKey}.title`)}</h2>
          <p>
            <a {...linkOptions} data-variant={upsellKey}>
              {I18n.t(`transfer.${upsellKey}.text`)}
            </a>
          </p>
        </div>
      </div>
      <div className="transfer__footer">
        <button className="transfer__button" onClick={onNewTransfer}>
          {I18n.t('transfer.buttons.continue')}
        </button>
      </div>
    </React.Fragment>
  );
};

Upsell.propTypes = {
  upsellKey: PropTypes.string.isRequired,
  onHandleUpsellClick: PropTypes.func.isRequired,
  onNewTransfer: PropTypes.func.isRequired,
};

export default Upsell;
